exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FlashExercise-module__flash-exercise___24R6R{-webkit-user-select:none;-moz-user-select:none;user-select:none;display:flex;justify-content:center}.FlashExercise-module__flash-exercise___24R6R .FlashExercise-module__wrapper___1-d7g{display:grid}", ""]);

// exports
exports.locals = {
	"flash-exercise": "FlashExercise-module__flash-exercise___24R6R",
	"wrapper": "FlashExercise-module__wrapper___1-d7g"
};